// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__4_RZd","error":"Textarea_error__27gWH","readonly":"Textarea_readonly__2mr6z","disabled":"Textarea_disabled__3GDEJ"};